import * as React from "react"
import type { SVGProps } from "react"
const SvgTagMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.15 22.29a2 2 0 0 1-1.43-.6l-7.15-7.15q-.3-.3-.43-.67a2 2 0 0 1 0-1.48q.13-.38.43-.68l7.8-7.82q.28-.28.66-.44a2 2 0 0 1 .77-.16h7.18q.83 0 1.4.58.6.6.6 1.42v7.17q0 .3-.09.57a6 6 0 0 0-1.91-.66V5.29h-7.15L4 13.14l7.15 7.15.94-.95a6 6 0 0 0 .78 2.06l-.3.29a2 2 0 0 1-1.42.6" />
    <path d="M15.48 10.29q.61 0 1.06-.44.44-.45.44-1.06t-.44-1.07a1.5 1.5 0 0 0-1.06-.43q-.62 0-1.07.43a1.5 1.5 0 0 0-.43 1.07q0 .62.43 1.06.45.44 1.07.44m-1.2 8.7q.3.3.72.3h6q.42 0 .71-.3a1 1 0 0 0 .29-.7 1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.28h-6a1 1 0 0 0-.71.28 1 1 0 0 0-.29.72q0 .43.29.7" />
  </svg>
)
export default SvgTagMinus
